// @systeme: interface
// Cinq onglets en bas, jamais plus (docs/produit.md §6).
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import { CalendarDays, ListChecks, StickyNote, Sun, UserRound } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router';

const ONGLETS = [
  { chemin: '/', libelle: 'Aujourd’hui', Icone: Sun },
  { chemin: '/a-venir', libelle: 'À venir', Icone: CalendarDays },
  { chemin: '/listes', libelle: 'Listes', Icone: ListChecks },
  { chemin: '/notes', libelle: 'Notes', Icone: StickyNote },
  { chemin: '/moi', libelle: 'Moi', Icone: UserRound },
] as const;

export function NavigationBasse() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // L'onglet reste allumé sur ses sous-écrans (/listes/…, /a-venir/…).
  const courant =
    ONGLETS.find((o) => o.chemin !== '/' && pathname.startsWith(o.chemin))?.chemin ?? '/';
  return (
    <Paper
      component="nav"
      elevation={0}
      square
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        borderTop: 1,
        borderColor: 'divider',
        pb: 'env(safe-area-inset-bottom)',
      }}
    >
      <BottomNavigation
        value={courant}
        onChange={(_e, chemin: string) => navigate(chemin)}
        showLabels
      >
        {ONGLETS.map(({ chemin, libelle, Icone }) => (
          <BottomNavigationAction
            key={chemin}
            value={chemin}
            label={libelle}
            icon={<Icone size={24} aria-hidden />}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
}
